// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Belt_Result from "../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function to_string(value) {
  switch (value) {
    case /* Mg */0 :
        return "mg";
    case /* Flexi */1 :
        return "flexi";
    case /* Insti */2 :
        return "insti";
    case /* TripBased */3 :
        return "trip_based";
    
  }
}

function from_string(value) {
  switch (value) {
    case "flexi" :
        return /* Flexi */1;
    case "insti" :
        return /* Insti */2;
    case "mg" :
        return /* Mg */0;
    case "trip_based" :
        return /* TripBased */3;
    default:
      return ErrorUtils$Catalyst.raiseError("PartnerEngagement.re", "Invalid engagement type", value);
  }
}

function t_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), from_string);
}

var engagement_types = {
  hd: /* Mg */0,
  tl: {
    hd: /* Flexi */1,
    tl: {
      hd: /* Insti */2,
      tl: {
        hd: /* TripBased */3,
        tl: /* [] */0
      }
    }
  }
};

export {
  to_string ,
  engagement_types ,
  from_string ,
  t_decode ,
  
}
/* No side effect */
